import { render, staticRenderFns } from "./AgentCommoditySelect.vue?vue&type=template&id=704e69e2&scoped=true"
import script from "./AgentCommoditySelect.vue?vue&type=script&lang=ts"
export * from "./AgentCommoditySelect.vue?vue&type=script&lang=ts"
import style0 from "./AgentCommoditySelect.vue?vue&type=style&index=0&id=704e69e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e69e2",
  null
  
)

export default component.exports